import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Modal, Form, Alert } from "react-bootstrap";
import { useAuth } from "../Context/AuthContext";
import axios from "axios";
import { Base_URL } from "../url";
import { FaUserCheck, FaCoffee, FaCalendarAlt, FaHome } from "react-icons/fa";
import '../Styling/PunchInMaster.css';
import AttendanceModal from "../Pages/AttendanceModal"; // ✅ ADDED

const PunchInMaster = ({ setAttendanceUpdated }) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [showAttendanceModal, setShowAttendanceModal] = useState(false); // ✅ ADDED
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [formData, setFormData] = useState({
    userId: user?.userId || "",
    startDate: "",
    endDate: "",
    reason: ""
  });

  const [formErrors, setFormErrors] = useState({
    startDate: "",
    endDate: "",
    reason: ""
  });

  // ✅ UPDATED (reset logic added)
  const openModal = () => {
    setFormData({
      userId: user?.userId || "",
      startDate: "",
      endDate: "",
      reason: ""
    });
    setFormErrors({
      startDate: "",
      endDate: "",
      reason: ""
    });
    setError("");
    setSuccess("");
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (formErrors[name]) setFormErrors({ ...formErrors, [name]: "" });
  };

  // ✅ ADDED validation logic
  const validateForm = () => {
    const errors = {};
    const today = new Date().toISOString().split("T")[0];

    if (!formData.startDate) {
      errors.startDate = "Start date is required";
    }
    // } else if (formData.startDate < today) {
    //   errors.startDate = "Start date cannot be in the past";
    // }

    if (!formData.endDate) {
      errors.endDate = "End date is required";
    }
    // } else if (formData.endDate < formData.startDate) {
    //   errors.endDate = "End date cannot be before start date";
    // }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // ✅ ADDED submit logic
  const handleSubmit = async () => {
    if (!validateForm()) return;

    setLoading(true);
    setError("");
    setSuccess("");

    const payload = {
      userId: formData.userId,
      startDate: formData.startDate,
      endDate: formData.endDate,
      reason: formData.reason,
      leaveType: "WFH",
      organisationId: user?.organisationId,
    };

    try {
      await axios.post(`${Base_URL}/Leave/ApplyWFH`, payload, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
          "Content-Type": "application/json",
        },
      });

      setSuccess("WFH Request Sent Successfully!");
      setTimeout(() => closeModal(), 1000);
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to submit WFH request.");
    } finally {
      setLoading(false);
    }
  };

  // ❌ navigation REMOVED → modal used instead
  const handlePostAttendance = () => setShowAttendanceModal(true);
  const handleRequestLeave = () => navigate("/request-leave");

  const tiles = [
    {
      title: "Post Attendance",
      subtitle: "Tap to post your attendance",
      icon: <FaUserCheck />,
      color: "green",
      summary: user?.userId || "User ID",
      onClick: handlePostAttendance
    },
    {
      title: "Break",
      subtitle: "Take a short break",
      icon: <FaCoffee />,
      color: "orange",
      summary: "N/A",
      onClick: () => alert("Break functionality coming soon!")
    },
    {
      title: "Request Leave",
      subtitle: "Submit your leave requests",
      icon: <FaCalendarAlt />,
      color: "blue",
      summary: user?.role || "Role",
      onClick: handleRequestLeave
    },
    {
      title: "Work From Home",
      subtitle: "Apply for WFH request",
      icon: <FaHome />,
      color: "teal",
      summary: "WFH",
      onClick: openModal
    }
  ];

  return (
    <div className="resource-master">
      <Card className="punchin-master-card shadow-sm">
        <Card.Body>
          <div className="action-grid">
            {tiles.map((tile, idx) => (
              <div
                key={idx}
                className={`action-tile icon-${tile.color}`}
                onClick={tile.onClick}
                tabIndex={0}
                role="button"
              >
                <div className="tile-icon">{tile.icon}</div>
                <div className="tile-title">{tile.title}</div>
                <div className="tile-subtitle">{tile.subtitle}</div>
                <div className="tile-footer">{tile.summary}</div>
              </div>
            ))}
          </div>
        </Card.Body>
      </Card>

      {/* ✅ Attendance Modal */}
      <AttendanceModal
        show={showAttendanceModal}
        onHide={() => setShowAttendanceModal(false)}
        user={user}
        onAttendanceSuccess={() => {
          setAttendanceUpdated(prev => !prev); // 🔥 TRIGGER REFRESH
          setShowAttendanceModal(false);
        }}
      />


      {/* WFH Modal */}
      <Modal show={showModal} onHide={!loading ? closeModal : null} centered>
        <Modal.Header closeButton={!loading}>
          <Modal.Title>Work From Home Request</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          {success && <Alert variant="success">{success}</Alert>}

          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Start Date <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="date"
                name="startDate"
                value={formData.startDate}
                onChange={handleChange}
                isInvalid={!!formErrors.startDate}
                disabled={loading}
          min={new Date(new Date().setDate(new Date().getDate() - 15))
  .toISOString()
  .split("T")[0]}

              />
              <Form.Control.Feedback type="invalid">{formErrors.startDate}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>End Date <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="date"
                name="endDate"
                value={formData.endDate}
                onChange={handleChange}
                isInvalid={!!formErrors.endDate}
                disabled={loading}
             min={
  new Date(
    new Date( new Date())
      .setDate(
        new Date(new Date()).getDate() - 15
      )
  )
    .toISOString()
    .split("T")[0]
}

              />
              <Form.Control.Feedback type="invalid">{formErrors.endDate}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Reason <span className="text-danger">*</span></Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="reason"
                value={formData.reason}
                onChange={handleChange}
                placeholder="Enter your reason..."
                disabled={loading}
              />
              <Form.Text className="text-muted">Minimum 10 characters required</Form.Text>
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <button className="btn btn-secondary" onClick={closeModal} disabled={loading} type="button">
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={loading} type="button">
            {loading ? "Submitting..." : "Submit Request"}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PunchInMaster;
